import { render, staticRenderFns } from "./BookingTabsNotes.vue?vue&type=template&id=d69d2f3a&scoped=true&"
import script from "./BookingTabsNotes.vue?vue&type=script&lang=js&"
export * from "./BookingTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69d2f3a",
  null
  
)

export default component.exports